import { type ReactNode, useMemo } from 'react';
import InfoTooltip from '~/components2/InfoTooltip';

interface Props {
  title: ReactNode;
  tooltip?: ReactNode;
  /** Renders the title as a heading at this level; omit for a plain label. */
  headingLevel?: 2 | 3;
  children: ReactNode;
  'data-testid'?: string;
}

export default function Section({ title, tooltip, headingLevel, children, 'data-testid': testId }: Props) {
  const sectionTitle = useMemo(() => {
    const TitleTag = headingLevel ? (`h${headingLevel}` as const) : 'div';
    if (tooltip) {
      return (
        <div className="my-2 flex font-noto text-base">
          <TitleTag className="mr-1 items-center font-semibold">{title}</TitleTag>
          {tooltip && (
            <InfoTooltip text={tooltip} label={typeof title === 'string' ? `About ${title}` : 'More information'} />
          )}
        </div>
      );
    } else {
      return (
        <div className="my-2 flex font-noto text-base">
          <TitleTag className="mr-1 w-full items-center font-semibold">{title}</TitleTag>
        </div>
      );
    }
  }, [title, tooltip, headingLevel]);

  return (
    <div data-testid={testId}>
      {sectionTitle}
      {children}
    </div>
  );
}
